import ListingPage from 'components/Listing'
import { CareGuidePageProps } from 'types/careguide-page'

const CareListingPage = (props: CareGuidePageProps<{}>) => {
  return (
    <ListingPage {...props} pageProps={{ ...props.pageProps, analyticsPageType: 'care-listing' }} />
  )
}

export default CareListingPage
